(() => {
  const selector =
    "#MainContent > .shopify-section[data-marketing-landing-reveal='true']:not([data-marketing-landing-reveal-excluded='true'])";
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const excludeFirstBestSellers = () => {
    const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
    const firstBestSellers = sections.find((section) =>
      Array.from(section.querySelectorAll('h1, h2, h3')).some(
        (heading) => heading.textContent.replace(/\s+/g, ' ').trim().toUpperCase() === '# BEST SELLERS'
      )
    );

    if (!firstBestSellers) return;

    firstBestSellers.dataset.marketingLandingRevealExcluded = 'true';
    firstBestSellers.removeAttribute('data-marketing-landing-reveal');
    firstBestSellers.removeAttribute('data-reveal-visible');
    observer?.unobserve(firstBestSellers);
  };

  const show = (element, reduced = false) => {
    if (reduced) element.dataset.reducedMotion = 'true';
    element.dataset.revealVisible = 'true';
    observer?.unobserve(element);
  };

  const showAll = (reduced = false) => {
    document.querySelectorAll(selector).forEach((element) => show(element, reduced));
  };

  const observe = (element) => {
    if (
      element.dataset.revealVisible === 'true' ||
      element.dataset.marketingLandingRevealExcluded === 'true'
    ) {
      return;
    }
    observer.observe(element);
  };

  const start = () => {
    excludeFirstBestSellers();

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      showAll(true);
      document.documentElement.classList.remove('getmeasure-scroll-reveal-enabled');
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) show(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.16,
      }
    );

    document.querySelectorAll(selector).forEach(observe);
  };

  reducedMotion.addEventListener('change', (event) => {
    if (!event.matches) return;
    observer?.disconnect();
    showAll(true);
    document.documentElement.classList.remove('getmeasure-scroll-reveal-enabled');
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    const main = document.querySelector('#MainContent');

    if (
      !observer ||
      !(section instanceof HTMLElement) ||
      section.parentElement !== main ||
      section === main.firstElementChild ||
      section.getBoundingClientRect().height <= 0
    ) {
      return;
    }

    section.dataset.marketingLandingReveal = 'true';
    excludeFirstBestSellers();
    observe(section);
  });

  start();
})();
